import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/createSegment', params).then((response) => {
        return response.data;
    });
};
export const useMutationCreateSegment = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    segmentId: number | null;
    contractId: number | undefined;
    metaDataId: number | undefined;
    name: string;
    filter: {
        filters: {
            name: string;
            data: string[] | number[] | undefined;
        }[];
    };
    entireProject: boolean;
    userGenerated: boolean;
    url: string;
}
